export default function clearMapComponents({ map, cameras }) {
  const { floorPlans, markups } = map;

  [cameras, floorPlans, markups].forEach(type => {
    type.forEach(c => c.remove && c.remove())
  })
}



// WEBPACK FOOTER //
// ./src/helpers/map/clearMapComponents.js